import React, { useEffect, useRef, useState } from "react";
import CSSalesPipiline from "../../images/sales-pipeline.png";
import CSSalesTimeline from "../../images/sales-timeline.png";
import CSSalesTeamInbox from "../../images/sales-team-inbox.png";
import CSSalesReport from "../../images/sales-report.png";
import CSSalesCustomer from "../../images/sales-customer-journey.png";
import CSSalesCustomerMobile from "../../images/sales-customer-journey-mobile.png";
import Slider from 'react-slick';
import Parallax from "../common/utils/animations/parallax";
import { directions } from "../common/utils/animations/animationConstants";
import { motion } from 'framer-motion';


export default function CsPlatformIntro() {
  const [isMobile, setisMobile] = useState(false);
  const ref = useRef();
  useEffect(() => {
    const setValues = () => {
      setisMobile(window.innerWidth <= 767);
    };
    setValues();
    window.addEventListener('resize', () => {
      setValues();
    });
    return () => {
      window.removeEventListener('resize', () => {
        setValues();
      });
    };
  });

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="cs-platform-intro-section section-gap">
      <div className="platform-intro-top">
        <Slider {...settings}>
          <div className="platform-top-img">
            <img src={CSSalesPipiline} width="1029x" alt="salesmate CRM" title="salesmate" />
          </div>
          <div className="platform-top-img">
            <img src={CSSalesTimeline} width="1027px" alt="salesmate CRM" title="salesmate" />
          </div>
          <div className="platform-top-img">
            <img src={CSSalesTeamInbox} width="1027px" alt="salesmate CRM" title="salesmate" />
          </div>
          <div className="platform-top-img">
            <img src={CSSalesReport} width="1010px" alt="salesmate CRM" title="salesmate" />
          </div>
        </Slider>
        <div className="container-small">
          <div className="row d-flex flex-wrap section-gap platform-intro-middle justify-center">
            <div className="col">
              <h2 className="h3">A platform with infinite paths and possibilities</h2>
              <p>Our initial challenge was to decipher the vision of “Sales OS” to discover the product and core features that sales reps actually need and want to use. We also had to position Salesmate in its own category to ensure it did not look like just another CRM platform. Sure, you can manage your contacts and sales - but it so much more than that!</p>

              <p>We knew that Salesmate is not going to another app - it is going to be a highly complex, multi-faceted platform that has to meticulously balance form, function, and fun to create outstanding sales experiences. Besides, with the competitive market and demanding customer needs, Salesmate will have to grow and adapt quickly. </p>

              <p>To deliver on the Salesmate promise, we collaborated with the Salesmate team to devise the product strategy, roadmap, user experience, and platform architecture. We took an iterative approach with a long-term vision. To adopt to the changing needs and inherent complexity, we designed the entire platform to be modular, extendable, and intuitive - one component at a time.</p>
            </div>
          </div>
        </div>

      </div>
      <div ref={ref} className="platform-intro-bottom">
        <div className="container-small">
          <div className="row d-flex flex-wrap section-gap platform-intro-middle justify-center">
            <div className="col">
              <h2 className="h3">Accelerating the sales & customer journey</h2>
              <p>Frontline sales teams lose 30% of their time in data entry and a lot more than that to engage the prospects and customers at the right time, with the right message, and on the right channel.</p>

              <p>We could eliminate the data entry by automatically syncing and tracking every update, action, and interaction. All emails, meetings, calls, follow-ups, contacts, campaigns, deals, and much more - are now fully integrated, automated, and organized in real-time. It helps sales teams deeply understand their customers and their journey to have insightful conversations.</p>
            </div>
          </div>
        </div>
        <div className="platform-bottom-img">
          {!isMobile && <Parallax triggers={[1, 0.6]} id="sales-automation-img" direction={directions.BTT} length={100} opacity={true}>
            <motion.img src={CSSalesCustomer} alt="sales automation" title="crm sales automation" />
          </Parallax>}
          {isMobile && <>
            <div className="mobile-tooltip">
              <img src={CSSalesCustomerMobile} title="sales automation" alt="crm sales automation" />
              <div className="tooltip red tooltip-1">
                <div className="dot"></div>
                <div className="wave"></div>
                <div className="tooltip-content">Customer Information</div>
              </div>
              <div className="tooltip orange tooltip-2">
                <div className="dot"></div>
                <div className="wave"></div>
                <div className="tooltip-content">Built-in Communications</div>
              </div>
              <div className="tooltip teal tooltip-3">
                <div className="dot"></div>
                <div className="wave"></div>
                <div className="tooltip-content">Automatically Tracks Emails, <br />Calls, Text & Meetings  </div>
              </div>
              <div className="tooltip tooltip-4">
                <div className="dot"></div>
                <div className="wave"></div>
                <div className="tooltip-content">Event Tracking</div>
              </div>
              <div className="tooltip orange tooltip-5">
                <div className="dot"></div>
                <div className="wave"></div>
                <div className="tooltip-content">Planned Activities</div>
              </div>
              <div className="tooltip teal tooltip-6">
                <div className="dot"></div>
                <div className="wave"></div>
                <div className="tooltip-content">Engagement Summary</div>
              </div>
            </div>
          </>}

        </div>
      </div>
    </div>
  );
}
